
//import slider = require("slider");
//var select2Temp = slider;
import "bootstrap-slider";

export module Slider {

	export async function initAllAsync(container: JQuery): Promise<void> {

		var count = container.find("input.bootstrap-slider").not(".slider-rendered").length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find("input.bootstrap-slider").not(".slider-rendered"), async (i, e) => {
				var slider = new Slider($(e));
				await slider.initAsync();
				count -= 1;
				if (count <= 0)
					resolve();
			});

			//container.find("input.bootstrap-slider").not(".slider-rendered").each(async (i, e) => {
			//	var slider = new Slider($(e));
			//	await slider.initAsync();
			//	count -= 1;
			//	if (count <= 0)
			//		resolve();
			//});

		});

	}


	export class Slider {

		private elemenet: JQuery;


		constructor(element: JQuery) {
			this.elemenet = element;
		}

		public initAsync(): Promise<void> {

			var twoHandles = this.elemenet.data("twoHandles");
			var min = this.elemenet.data("min") || 0;
			var max = this.elemenet.data("max") || 1000;

			var options = <Types.SliderSettings>{
				handle: "round",
				min: min,
				max: max,
				precision: 0,
				tooltip_split: true,
			};

			var length = Math.abs(max - min);
			if (twoHandles)
				(<any>options).value = [min, max];


			return new Promise<void>((resolve, reject) => {

				if (this.elemenet.data("slider"))
					this.elemenet.data("slider").destroy();

				var parent1: JQuery | null = null;
				var parent2: JQuery | null = null;
				if (this.elemenet.is(":hidden")) {
					parent1 = this.elemenet.parent();
					parent2 = parent1.parent();
					parent1.appendTo($("#divPjaxContent"));
				}

				if (twoHandles)
					this.elemenet.val(min + "," + max);
				else
					this.elemenet.val(min);


				this.elemenet.data("originalMin", min);
				this.elemenet.data("originalMax", max);

				this.elemenet.slider(options);
				this.elemenet.addClass("slider-rendered");


				if ((parent1 != null) && (parent2 != null))
					parent1.appendTo(parent2);

				this.elemenet.parent().find(".tooltip.top").removeClass("top");
				var handleSum = 0;
				this.elemenet.parent().find(".slider-handle").each((i, e) => { handleSum += parseFloat($(e).css("left").replace("%", "")) });

				var width = this.elemenet.parent().find(".tooltip").width() || 40;
				var left = "calc(" + (handleSum / 2) + "% - " + width / 2 + "px)";
				this.elemenet.parent().find(".tooltip").css("left", left);

				resolve();
			});

		}


	}

}
